module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "book-header"
  }, [_c('span', {
    staticClass: "book-header-day"
  }, [_vm._v("今天")]), _vm._v(" "), _c('span', {
    staticClass: "book-header-date"
  }, [_vm._v("星期六 5月6日")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary book-add-button",
    attrs: {
      "id": "addBook"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addBook($event)
      }
    }
  }, [_c('md-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "book-group",
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.books), function(book) {
    return _c('md-layout', {
      key: book.id
    }, [_c('book', {
      attrs: {
        "progress": book.progress
      }
    }, [_c('span', {
      slot: "title"
    }, [_vm._v(_vm._s(book.name))]), _vm._v(" "), _c('span', {
      slot: "author"
    }, [_vm._v(_vm._s(book.author))])])], 1)
  })), _vm._v(" "), _c('md-dialog', {
    ref: "addBookDialog",
    attrs: {
      "md-open-from": "#addBook",
      "md-close-to": "#addBook"
    }
  }, [_c('md-dialog-title', [_vm._v("添加书单")]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "书名"
    },
    model: {
      value: (_vm.bookName),
      callback: function($$v) {
        _vm.bookName = $$v
      },
      expression: "bookName"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "作者"
    },
    model: {
      value: (_vm.bookAuthor),
      callback: function($$v) {
        _vm.bookAuthor = $$v
      },
      expression: "bookAuthor"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": "进度",
      "type": "number"
    },
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  })], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('cancel')
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.closeDialog('confirm')
      }
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-756d7da5"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/plugins/BookList.vue
// module id = 352
// module chunks = 1